import { ReactComponent as TypingIcon } from './typingIcon.svg'
import styles from './TypingMessage.module.scss'

const TypingMessage = ({ typingUsers }) => {
  const usersArray = Object.values(typingUsers).map(u => u.firstName)

  return (
    <>
      {Object.values(typingUsers).length > 0 ? (
        <div className={styles.container}>
          <TypingIcon />
          <TypingText usersArray={usersArray} />
        </div>
      ) : null}
    </>
  )
}

const TypingText = ({ usersArray }) => {
  if (usersArray.length === 1) {
    return (
      <div>
        <span className={styles.name}>{usersArray[0]}</span>
        &nbsp;
        <span>is typing...</span>
      </div>
    )
  }

  if (usersArray.length === 2) {
    return (
      <div>
        <span className={styles.name}>{usersArray[0]}</span>
        &nbsp;
        <span>are</span>
        &nbsp;
        <span className={styles.name}>{usersArray[1]}</span>
        &nbsp;
        <span>typing...</span>
      </div>
    )
  }

  if (usersArray.length > 2) {
    return (
      <div>
        {usersArray.slice(0, usersArray.length - 1).map((name, i) => (
          <span key={name} className={styles.name}>
            {name}
            {i !== usersArray.length - 2 && ', '}
          </span>
        ))}
        <span> and </span>
        <span className={styles.name}>{usersArray[usersArray.length - 1]}</span>
        <span> are typing...</span>
      </div>
    )
  }

  return null
}

export default TypingMessage
